import { getGlobalTheme } from '@atlaskit/tokens';
import type { MakeBridgeContext } from '../types';
import type { TBridgeMethod } from './types';

type EnableThemingContext = MakeBridgeContext<'environment' | 'bridgeControls'>;

/**
 * Activates theming in the iframe by reading the current host theme and pushing
 * it to the open bridge connection via `BridgeControls.setTheme`.
 *
 * Called by the Forge app's `@forge/bridge` when the app opts in to platform
 * theming. `surfaceColor` is always `null` here — the initial surface colour is
 * sent during the bridge handshake. This path only handles theme-mode changes.
 */
export const enableTheming: TBridgeMethod<EnableThemingContext, void, void> = async ({
	environment,
	bridgeControls,
}) => {
	const currentTheme = getGlobalTheme();
	bridgeControls.setTheme(currentTheme, null, environment);
};
